import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./SegmentedControl.module.scss";
export function SegmentedControl({ value, onChange, options, fullWidth = false, className, ariaLabel, }) {
    return (_jsx("div", { role: "tablist", "aria-label": ariaLabel, className: cn(styles.root, fullWidth && styles.fullWidth, className), children: options.map((o) => (_jsx("button", { type: "button", role: "tab", "aria-selected": o.value === value, disabled: o.disabled, onClick: () => onChange(o.value), className: cn(styles.item, o.value === value && styles.active), children: o.label }, o.value))) }));
}
